/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarImgSlider\CarImgSlider.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import React, { useEffect, useState } from "react";
import styles from "Content/Car/CarImgSlider/CarImgSlider.module.css";
import { CarImgSliderPropsType, PictureType } from "Content/Car/CarImgSlider/CarImgSliderProps.type";
import translator from "MultiLanguage/TranslationWrapper";
import { Skeleton } from "@mui/material";

function CarImgSlider (props: CarImgSliderPropsType) {
    const [firstPicture, setFirstPicture] = useState("");
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (firstPicture == "")
            getFirstPictureUrl(props.url!);
    }, [firstPicture]);

    const getFirstPictureUrl = async (url: string) => {
        const myPictures: PictureType[] = await (await fetch(url)).json();
        if (myPictures.length > 0 )
            setFirstPicture(myPictures[0].URI);
        else
            setFirstPicture(`/PH${props.subSection}.svg`);
    };

    return (
        <React.Fragment>
            <div className={`${styles.imgSlider}`}>
                {
                    props.status.toLowerCase() == "sold" ? <div className={`${styles.sold}`}> <p>{translator.decode("car.sold")}</p> </div> : null
                }
                {
                    props.status.toLowerCase() == "reserved" ? <div className={`${styles.reserved}`}> <p>{translator.decode("car.reserved")}</p> </div> : null
                }
                {!loaded && (
                    <Skeleton variant="rectangular" width="100%" height={180} className={styles.CarImgSlider} animation="wave" />
                )}
                <div className="car_img">
                    <img className={styles.CarImgSlider} style={{ display: loaded ? 'block' : 'none' }} src={firstPicture} alt={firstPicture} onLoad={() => setLoaded(true)} onError={() => setLoaded(false)} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default CarImgSlider;
